import * as React from 'react';
import { Breadcrumbs as BreadcrumbsBase, Text, createStyles } from '@mantine/core';
import { Link } from 'react-router-dom';

// Components
import { Card } from '../Card';

interface Step {
    label: string;
    link?: string;
}

interface BreadcrumbsProps {
    steps: Step[];
}

const useStyles = createStyles((theme) => ({
    cardStyle: {
        [theme.fn.smallerThan('sm')]: {
            // margin: 0,
            // position: 'absolute',
            // top: '3rem',
            // left: 0,
            // right: 0
            display: 'none'
        }
    },
    root: {
        padding: '1rem',
        // background: '#ededed',
        fontWeight: 500,
        [theme.fn.smallerThan('sm')]: {
            padding: '0 1rem'
        }
    },
    breadcrumb: {
        [theme.fn.smallerThan('sm')]: {
            lineHeight: '2rem'
        }
    },
    link: {
        textDecoration: 'none',
        // color: theme.colors.cyan[7]
        color: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color
    }
}));

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ steps }) => {
    const { classes } = useStyles();

    return (
        <Card my="lg" className={classes.cardStyle}>
            <BreadcrumbsBase
                // separator="→"
                classNames={{
                    root: classes.root,
                    breadcrumb: classes.breadcrumb
                }}
            >
                {steps.map((step, index) =>
                    step.link ? (
                        <Link key={index} to={step.link} className={classes.link}>
                            {step.label}
                        </Link>
                    ) : (
                        <Text key={index}>{step.label}</Text>
                    )
                )}
            </BreadcrumbsBase>
        </Card>
    );
};
